import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from "react-dom";
import PopoverComponent from "src/core/gd-components/base-component/popover-component";

import Popover from 'src/core/gd-components/gd-popover/popover';
import VScroll from 'src/core/gd-components/scrolling/custom-v-scroll/v-scroll';
import SortInfo from 'src/core/gd-components/popover-menu/popover-help-hint/popover-help-hint-depricated';

import HintPopover from 'src/core/gd-ui/hint-popover/hint-popover';

// THIS IS DEPRICATED - what is new one ?
export default class SelectorWithInfo extends PopoverComponent {

    static propTypes = {
        size: PropTypes.oneOf(['normal','fixed-150', 'controls', 'fixed-110-26', 'controls-22']),

        type: PropTypes.oneOf(['default','default-square','icon-only','static-icon-label','no-border','underlined','top-control', 'top-control-2', 'control-main-selector']),
        icon: PropTypes.string,

        staticLabel: PropTypes.string, //static-icon-label type only

        items: PropTypes.array,
        selectedId: PropTypes.any, //PropTypes.string,
        onChange: PropTypes.func,

        placeHolder: PropTypes.string,
        hint: PropTypes.string,
        defaultInfo: PropTypes.string,

        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,

        popoverClassName: PropTypes.string,
        style: PropTypes.object
    };

    static defaultProps = {
        size: 'normal',
        type: 'default',
        placeHolder: '',
        attachment: 'top center',
        targetAttachment: 'bottom center',
        style: {}
    };

    handleHoverOn = (info) => {
        if (this.refs.sortInfo) this.refs.sortInfo.setMessage(info);
    };

    handleHoverOff = () => {
        if (this.refs.sortInfo) this.refs.sortInfo.setMessage(null);
    };

    onOptionClick = (id, e) => {
        e.stopPropagation();
        this.hidePopover(e,()=>{
            if (this.props.onChange) this.props.onChange(id);
        });
    };

    renderOptionItems = () => {
        return this.props.items && this.props.items.map((i,key)=>{

            const selected = this.props.selectedId ? this.props.selectedId === i.id : i.id === null;
            const classes = Classes('action', {
                selected: selected,
                'with-icon': !!i.icon
            });

            return (
                <div key={key+"_"+i.id}
                     className={classes}
                     onMouseEnter={this.handleHoverOn.bind(this, i.info)}
                     onMouseLeave={this.handleHoverOff}
                     onClick={this.onOptionClick.bind(this,i.id)}>
                    {!!i.icon && <div className={Classes("action-icon", i.icon)} />}
                    {i.label}
                </div>
            );
        });
    };

    renderPopover = () => {
        if (this.state.showPopover) {
            const option = _.find(this.props.items, i=>i.id === this.props.selectedId);
            const defaultMessage = option && option.info ? option.info : this.props.defaultInfo;

            return (
                <Popover className="gd-selector-with-info-container"
                         popoverClass={Classes("gd-selector-with-info-popover", this.props.popoverClassName)}
                         attachment={this.props.attachment}
                         targetAttachment={this.props.targetAttachment}
                         attachmentType="horizontal"
                         onClickOutside={()=>{this.hidePopover()}}
                         getTargetFunc={()=>findDOMNode(this)}>

                    <VScroll className="gd-popup-menu-items"
                             scrollVisibility="auto">
                        {this.renderOptionItems()}
                    </VScroll>

                    {defaultMessage &&
                    <SortInfo ref="sortInfo"
                              defaultMessage={defaultMessage}
                              noBorder={true}/>}

                </Popover>
            );
        } else {
            return null;
        }
    };

    renderLabel = () => {
        let res;

        switch (this.props.type) {
            case 'default':
            case 'default-square':
            case 'no-border':
            case 'underlined':
                const option = this.props.selectedId ? _.find(this.props.items, o=>o.id === this.props.selectedId) : null;
                let label = this.props.placeHolder;
                if (option) {
                    const labelClasses = Classes("gd-selector-with-info-label", {
                        'is-default': option.default
                    });
                    const text = option.valueLabel ? option.valueLabel : option.label;
                    label = <div className={labelClasses}>{text}</div>;
                }

                res = (
                    <div className="gd-selector-with-info-button">
                        {label}
                        <div className="gd-selector-with-info-icon i5-big-angle-down"> </div>
                    </div>
                );
                break;

            case 'icon-only':
                res = (
                    <div className="gd-selector-with-info-button">
                        <div className={Classes("gd-selector-with-info-icon ", this.props.icon)}> </div>
                    </div>
                );
                break;

            case 'static-icon-label':
                res = (
                    <div className="gd-selector-with-info-button">
                        <div className={Classes("gd-selector-with-info-icon ", this.props.icon)}> </div>
                        {this.props.staticLabel}
                    </div>
                );
                break;

            case 'top-control': {
                const option = this.props.selectedId ? _.find(this.props.items, o=>o.id === this.props.selectedId) : null;

                res = (
                    <div className="btn with-text no-default-margin">
                        {option.icon && <div className={option.icon}/>}
                        <div className="label ui5-txt-not-important m-l-5">{option.label}</div>
                    </div>
                );
            } break;

            case 'top-control-2': {
                const option = this.props.selectedId ? _.find(this.props.items, o=>o.id === this.props.selectedId) : null;

                res = (
                    <div className="btn with-text no-decoration no-default-margin selected">
                        {option.icon && <div className={option.icon}/>}
                        <div className="label ui5-txt-not-important m-l-10">{option.label}</div>
                        <div className="arrow ui5-arrow-toggle s8 open m-l-5"/>
                    </div>
                );
            } break;

            case 'control-main-selector': {
                const option = this.props.selectedId ? _.find(this.props.items, o=>o.id === this.props.selectedId) : null;

                // let label = this.props.placeHolder;
                // if (option) {
                //     const labelClasses = Classes("gd-selector-with-info-label", {
                //         'is-default': option.default
                //     });
                //     const text = option.valueLabel ? option.valueLabel : option.label;
                //     label = <div className={labelClasses}>{text}</div>;
                // }

                res = (
                    <div className="gd-selector-with-info-button">
                        {option.icon && <div className={option.icon}/>}
                        <div className="label ui5-txt-not-important m-l-10">{option.label}</div>
                        <div className="arrow ui5-arrow-toggle s8 open m-l-5"/>
                    </div>
                );
            }
        }

        return res;
    };

    render() {
        const classes = Classes("gd-selector-with-info", this.props.size+"-size", this.props.type+"-type", this.props.className, {
            "is-selected": !!this.props.selectedId
        });

        return (
            <div className={classes} style={this.props.style} onClick={this.togglePopover}>
                {this.renderLabel()}
                {this.renderPopover()}
                {this.props.hint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.hint}/> }
            </div>
        );
    }
}